import React, { Component } from 'react';

import { Row, Col, Table } from "react-bootstrap";
import Card from "components/Card/Card.jsx";

import { connect } from 'react-redux';

import { formatToDecimal, roundNumber } from 'utils/Number/NumberUtils';

import { RESERVE } from 'constants/draftSaleOrderPaymentTypeConst';

class PaymentDetail extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    render() {
        return (
            <div>
                <Row>
                    <Col md={12}>
                        <Card
                            title={<b>Detalle de Pago</b>}
                            content={
                                <Row>
                                    <Col md={12}>
                                        <p className="pull-left"><b>Lote: </b>{this.props.saleOrder.name}</p>
                                        <br />
                                    </Col>
                                    <Col md={12}>
                                        <p className="pull-left">
                                            <b> {this.props.successPayment ? "Total Pagado: " : "Total a Pagar: "}    </b>
                                            {formatToDecimal(roundNumber(this.props.totalToPay, 2))}$
                                            {this.props.draftSaleOrderPaymentType == RESERVE ? " (Pago de Reserva)" : ""}
                                        </p>
                                        <br />
                                    </Col>
                                    <Col md={12}>
                                        {this.props.paymentMethod !== null &&
                                            <p><b>Método de Pago:</b> {this.props.paymentMethod.name}</p>
                                        }
                                    </Col>
                                    <Col md={12}>
                                        <Table striped responsive>
                                            <thead>
                                                {this.props.successPayment ?
                                                    <tr>
                                                        <th>Descripción</th>
                                                        <th className="text-right">Monto($)</th>
                                                        <th className="text-right">Saldo Por Pagar($)</th>
                                                    </tr>
                                                    :
                                                    <tr>
                                                        <th>Descripción</th>
                                                        <th className="text-right">Monto($)</th>
                                                        <th className="text-right">Saldo Por Pagar($)</th>
                                                        <th className="text-right">Saldo Futuro($)</th>
                                                    </tr>
                                                }
                                            </thead>
                                            <tbody>
                                                {this.props.quotas.map((quota, key) => {
                                                    let color = "";
                                                    if (quota.currentBalance == quota.futureBalance) {
                                                        color = "warning";
                                                    } else {
                                                        color = "success"
                                                    }

                                                    let rows = this.props.successPayment ?
                                                        <tr key={key} className={color}>
                                                            <td>{quota.description}</td>
                                                            <td className="text-right">{formatToDecimal(quota.amount)}</td>
                                                            <td className="text-right">{formatToDecimal(roundNumber(quota.futureBalance, 2))}</td>
                                                        </tr> :
                                                        <tr key={key} className={color}>
                                                            <td>{quota.description}</td>
                                                            <td className="text-right">{formatToDecimal(quota.amount)}</td>
                                                            <td className="text-right">{formatToDecimal(quota.currentBalance)}</td>
                                                            <td className="text-right">{formatToDecimal(roundNumber(quota.futureBalance, 2))}</td>
                                                        </tr>
                                                    return (
                                                        rows
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </Col>

                                </Row>
                            }>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    quotas: state.quotasToPay.quotasDetail,
    totalToPay: state.quotasToPay.totalToPay,
    saleOrder: state.quotasToPay.saleOrder,
    paymentMethod: state.quotasToPay.paymentMethod,
    draftSaleOrderPaymentType: state.quotasToPay.draftSaleOrderPaymentType
});
export default connect(mapStateToProps, {})(PaymentDetail);


// WEBPACK FOOTER //
// ./src/components/PaymentWizard/PaymentDetail.jsx